import React, { useState, useEffect, useContext } from 'react'
import Toggle from 'components/Toggle'
import { Button } from 'antd'
import { useMutation } from '@apollo/client'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LegalFormalityDocumentContext } from 'contexts/LegalFormalityDocumentContext'
import { LEGAL_FORMALITY_DOCUMENT_UPDATE_CHECKS_MUTATION } from 'graphql/LegalFormalities'

import { ChecksWrapper, Check, Instructions } from '../../styles'

interface Icheck {
  id: string
  status: string
}

const Checks = () => {
  const { legalFormalityRefetch } = useContext(CurrentLegalFormalityContext)
  const { currentDocument, setCurrentDocument } = useContext(
    LegalFormalityDocumentContext
  )
  const doc = currentDocument

  const [updateLegalDocumentChecks] = useMutation(
    LEGAL_FORMALITY_DOCUMENT_UPDATE_CHECKS_MUTATION
  )
  const [checkStates, setCheckStates] = useState([] as Icheck[])

  useEffect(() => {
    const checks =
      doc &&
      doc.checks.map(check => {
        return { id: check.id, status: check.status } as Icheck
      })
    setCheckStates(checks || [])
  }, [doc])

  if (!doc || !(doc.state === 'pending')) {
    return null
  }

  const toggleCheck = (check: Icheck) => (value: string) => {
    setCheckStates(checkStates => {
      const states = [...checkStates]
      const index = states.findIndex(c => c.id === check.id)
      states[index] = { id: check.id, status: value }
      return states
    })
  }

  const postCallback = (data: any) => {
    const newDoc =
      data.data.legalFormalityDocumentUpdateChecks.legalFormalityDocument
    legalFormalityRefetch()
    setCurrentDocument(newDoc)
  }

  const post = () => {
    updateLegalDocumentChecks({
      variables: {
        legalDocumentId: doc.id,
        checks: checkStates,
        validateDocument: true,
      },
    }).then(postCallback)
  }

  const toggleValues = [
    { value: 'in_error', color: '#E06611' },
    { value: 'pending', color: '#B9C4CD' },
    { value: 'validated', color: '#008140' },
  ]

  return (
    <ChecksWrapper className={'checklist-wrapper'}>
      {doc.checks.map(check => {
        return (
          <Check key={check.id}>
            <Toggle
              onClick={toggleCheck(check)}
              defaultPosition={toggleValues.findIndex(
                obj => obj.value === check.status
              )}
              values={toggleValues}
              disabled={check.status !== 'pending'}
            />
            <Instructions>{check.instructions}</Instructions>
          </Check>
        )
      })}
      <Button type="primary" onClick={() => post()}>
        Valider
      </Button>
    </ChecksWrapper>
  )
}

export default Checks
